import React from "react";
// import paulIcon from "../images/paul-icon.png";

const CirclesDeco: React.FC = () => (
  <svg
    viewBox="0 0 777 604"
    className="absolute top-0 left-0 w-full pointer-events-none"
    aria-hidden="true"
    style={{ zIndex: 0 }}
  >
    <g strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-903.000000, -48.000000)">
        <circle fill="#7EBEA5" cx="1117.23404" cy="65.0531915" r="6.60638298" />
        <circle fill="#7365FF" cx="1233.64894" cy="179.808511" r="8.80851064" />
        <circle
          fillOpacity="0.4"
          fill="#26295E"
          cx="912.138298"
          cy="363.319149"
          r="8.80851064"
        />
        <circle fill="#7365FF" cx="1510" cy="54.0957447" r="5.13829787" />
        <circle
          fillOpacity="0.6"
          fill="#7B9DED"
          cx="1573.51064"
          cy="193.755319"
          r="5.13829787"
        />
        <circle
          fillOpacity="0.6"
          fill="#7B9DED"
          cx="1167.17021"
          cy="309.861702"
          r="5.13829787"
        />
        <circle
          fillOpacity="0.6"
          fill="#7365FF"
          cx="1674.80851"
          cy="315.606383"
          r="5.13829787"
        />
        <circle
          fillOpacity="0.6"
          fill="#7B9DED"
          cx="1632.23404"
          cy="455.074468"
          r="5.13829787"
        />
        <circle fill="#26295E" cx="1055.57447" cy="179.56383" r="6.60638298" />
        <circle
          fillOpacity="0.6"
          fill="#7365FF"
          cx="986.276596"
          cy="264.223404"
          r="5.13829787"
        />
        <circle fill="#7B9DED" cx="1256.75532" cy="298.87234" r="2.93617021" />
        <circle
          fillOpacity="0.6"
          fill="#26295E"
          cx="1574.24468"
          cy="539.489362"
          r="2.93617021"
        />
        <circle
          fillOpacity="0.6"
          fill="#7B9DED"
          cx="1005.35106"
          cy="647.553191"
          r="4.40425532"
        />
        <circle fill="#7365FF" cx="1114.7234" cy="633.606383" r="6.60638298" />
        <circle fill="#7365FF" cx="1516.25532" cy="477.095745" r="6.60638298" />
        <circle
          fillOpacity="0.6"
          fill="#7EBEA5"
          cx="937.085106"
          cy="602.776596"
          r="8.07446809"
        />
        <circle fill="#7EBEA5" cx="1594.06383" cy="322.946809" r="8.07446809" />
      </g>
    </g>
  </svg>
);

const MessageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 30 30" className={className} style={{ width: "1em" }}>
    <path
      fill="currentColor"
      d="M10,10.31a.84.84,0,0,0-.59.23.81.81,0,0,0-.22.58V17.3a.78.78,0,0,0,.22.57.84.84,0,0,0,.59.23h.55V20a.28.28,0,0,0,.16.25.3.3,0,0,0,.3-.05l2.23-2.08h5.48a.84.84,0,0,0,.59-.23.78.78,0,0,0,.22-.57V11.12a.81.81,0,0,0-.22-.58.84.84,0,0,0-.59-.23Zm0,.54h8.72a.25.25,0,0,1,.2.07.24.24,0,0,1,.07.2V17.3a.27.27,0,0,1-.07.2.25.25,0,0,1-.2.07H13.16a.26.26,0,0,0-.19.07l-1.86,1.72V17.84a.28.28,0,0,0-.27-.27H10a.27.27,0,0,1-.2-.08.23.23,0,0,1-.07-.19V11.12a.24.24,0,0,1,.07-.2A.25.25,0,0,1,10,10.85Zm10.86,1.47a.29.29,0,0,0-.24.27v6.32c0,.11,0,.16-.06.19a.33.33,0,0,1-.22.08h-.94a.28.28,0,0,0-.27.27V21l-1.86-1.72a.26.26,0,0,0-.19-.07H13.56a.27.27,0,1,0,0,.54H17l2.23,2.07a.28.28,0,0,0,.29.05.27.27,0,0,0,.17-.24V19.72h.69a.91.91,0,0,0,.58-.23.82.82,0,0,0,.23-.58V12.59a.29.29,0,0,0-.31-.27Z"
    />
  </svg>
);

const BellIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 30 30" className={className} style={{ width: "1em" }}>
    <path
      fill="currentColor"
      d="M18.63,14.59V12.65A3.13,3.13,0,0,0,16.8,9.8a3.91,3.91,0,0,0-.75-.26V9.42a1.07,1.07,0,1,0-2.14,0v.14a4.23,4.23,0,0,0-.68.24,3.27,3.27,0,0,0-1.89,2.85v1.94A4.83,4.83,0,0,1,9.9,18.1a.21.21,0,0,0,.11.36l2,.36,1.06.16a2.11,2.11,0,0,0,3.82,0L18,18.82l2-.36a.21.21,0,0,0,.17-.14.2.2,0,0,0-.05-.22A4.83,4.83,0,0,1,18.63,14.59ZM14.34,9.42a.65.65,0,1,1,1.29,0v0a4,4,0,0,0-1.29,0ZM15,19.76A1.72,1.72,0,0,1,13.64,19a11.94,11.94,0,0,0,2.76,0A1.72,1.72,0,0,1,15,19.76Zm2.9-1.37-1.15.18h0l-.46.05h0l-.41,0h-.07l-.34,0h-.07c-.27,0-.53,0-.8,0h-.07l-.34,0h-.08l-.39,0h0l-.46-.05h0l-1.15-.18-1.64-.28a5.25,5.25,0,0,0,1.28-3.52V12.65a2.82,2.82,0,0,1,1.65-2.45,3.71,3.71,0,0,1,.75-.26h0a3.89,3.89,0,0,1,1.63,0h0a3.63,3.63,0,0,1,.83.26,2.74,2.74,0,0,1,1.57,2.46v1.94a5.25,5.25,0,0,0,1.36,3.52Z"
    />
    <path
      fill="currentColor"
      d="M16.51,10.7a3.88,3.88,0,0,0-2.92,0,2.22,2.22,0,0,0-1.39,1.87.23.23,0,0,0,.24.21h0a.22.22,0,0,0,.23-.21,1.79,1.79,0,0,1,1.12-1.48,3.36,3.36,0,0,1,2.53,0,.25.25,0,0,0,.31-.1A.22.22,0,0,0,16.51,10.7Z"
    />
    <circle cx="18.43" cy="11.6" r="1.85" fill="#7EBEA5" />
  </svg>
);

const LockIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 30 30" className={className} style={{ width: "1em" }}>
    <path
      fill="currentColor"
      d="M15.07,20.91a4.8,4.8,0,0,1-3-8.5.43.43,0,0,0,.18-.44,2.87,2.87,0,1,1,5.7-.53,1.64,1.64,0,0,0,.55,1.34,4.51,4.51,0,0,1,1.15,4.84,4.61,4.61,0,0,1-3.75,3.24l-.29.05C15.42,20.92,15.25,20.91,15.07,20.91Zm0-.5a4.3,4.3,0,1,0-4.29-4.29A4.28,4.28,0,0,0,15.08,20.41Zm2.34-8.49a2.36,2.36,0,0,0-3.7-2.29,2.24,2.24,0,0,0-1,2.28A4.89,4.89,0,0,1,17.42,11.92Z"
    />
    <path
      fill="currentColor"
      d="M15.37,12.52a3.59,3.59,0,0,1,3.29,3.1c0,.13,0,.25.05.38s0,.35-.24.37-.25-.16-.26-.35a3.08,3.08,0,0,0-1.27-2.4A2.84,2.84,0,0,0,15.37,13l-.15,0c-.17,0-.38,0-.35-.28s.24-.21.41-.21Z"
    />
    <path
      fill="currentColor"
      d="M15.09,14.46a.88.88,0,0,1,.86.62.83.83,0,0,1-.36,1,.48.48,0,0,0-.27.52c0,.18,0,.35,0,.53s0,.36-.24.35-.23-.19-.23-.36a5.23,5.23,0,0,1,0-.56.44.44,0,0,0-.25-.47.86.86,0,0,1-.37-1A.89.89,0,0,1,15.09,14.46Zm.41.92a.39.39,0,0,0-.4-.41.4.4,0,0,0-.41.4.41.41,0,0,0,.39.4A.42.42,0,0,0,15.5,15.38Z"
    />
  </svg>
);

const RadialProgress: React.FC = () => {
  const svgSize = 188;
  const cx = 94;
  const cy = 94;
  const r = 80;
  const circ = 2 * Math.PI * r;
  const dashArray = circ;
  const dashOffset = circ * 0.25;
  const marginPx = (14.3617 / 100) * svgSize;

  // const avatarSize = 82;

  return (
    <div
      className="relative bg-white"
      style={{
        padding: "32px 42px",
        boxShadow: "0 10px 40px 0 rgba(0,0,0,0.1)",
      }}
    >
      <div className="relative" style={{ width: svgSize, height: svgSize }}>
        <svg
          viewBox={`0 0 ${svgSize} ${svgSize}`}
          width={svgSize}
          height={svgSize}
          className="block"
        >
          <circle
            cx={cx}
            cy={cy}
            r={r}
            stroke="rgba(127, 191, 166, 0.1)"
            strokeWidth="27"
            fill="none"
          />

          <circle
            cx={cx}
            cy={cy}
            r={r}
            stroke="#E5E9FA"
            strokeWidth="7"
            fill="none"
          />

          <g
            style={{
              transform: "rotate(-90deg)",
              transformOrigin: `${cx}px ${cy}px`,
            }}
          >
            <circle
              cx={cx}
              cy={cy}
              r={r}
              stroke="#606060"
              strokeWidth="7"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={`${dashArray}`}
              strokeDashoffset={`${dashOffset}`}
            />
          </g>

          <g
            style={{
              transform: "rotate(270deg)",
              transformOrigin: "center center",
            }}
          >
            <circle cx={cx} cy={14} r="8" fill="#606060" />
          </g>
        </svg>

        <div
          className="absolute flex flex-col items-center justify-center"
          style={{
            top: marginPx,
            right: marginPx,
            bottom: marginPx,
            left: marginPx,
          }}
        >
          <span
            className="font-bold leading-none"
            style={{
              fontSize: 40,
              color: "var(--dark-blue)",
              fontFamily: "var(--font-primary)",
            }}
          >
            75%
          </span>

          <span
            className="mt-1"
            style={{
              fontSize: 13,
              color: "var(--meta)",
              fontFamily: "var(--font-primary)",
            }}
          >
            Collaborative
          </span>
        </div>
      </div>

      {/* <div
        className="absolute rounded-full overflow-hidden"
        style={{
          width: avatarSize,
          height: avatarSize,
          bottom: 7,
          right: 50,
          border: "3px solid white",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}
      >
        <img src={paulIcon} alt="User" className="w-full h-full object-cover" />

        <svg viewBox="0 0 82 82" width={avatarSize} height={avatarSize}>
          <rect width="82" height="82" fill="#FED7AA" />
          <circle cx="41" cy="32" r="19" fill="#F97316" />
          <ellipse cx="41" cy="70" rx="27" ry="19" fill="#FB923C" />
        </svg>
      </div> */}
    </div>
  );
};

const RadarChart: React.FC = () => {
  const W = 301;
  const H = 233;
  const cx = W / 2;
  const cy = H / 2;
  const r = 82;
  const n = 6;
  const gridRings = 6;

  const labels = [
    "Advancement",
    "Caring",
    "Collaborative",
    "Exploring",
    "Independent",
    "Safety",
  ];
  const values = [90, 75, 50, 70, 15, 40];

  const angle = (i: number) => -Math.PI / 2 + (2 * Math.PI * i) / n;

  const pt = (val: number, i: number) => {
    const a = angle(i);
    const d = (val / 100) * r;
    return {
      x: parseFloat((cx + d * Math.cos(a)).toFixed(2)),
      y: parseFloat((cy + d * Math.sin(a)).toFixed(2)),
    };
  };

  const ringPath = (pct: number) => {
    const pts = Array.from({ length: n }, (_, i) => pt(pct, i));
    return (
      pts.map((p, i) => `${i === 0 ? "M" : "L"}${p.x},${p.y}`).join(" ") + " Z"
    );
  };

  const dataPath =
    values
      .map((v, i) => {
        const p = pt(v, i);
        return `${i === 0 ? "M" : "L"}${p.x},${p.y}`;
      })
      .join(" ") + " Z";

  const labelPos = (i: number) => {
    const a = angle(i);
    const nudge = [16, 14, 14, 16, 18, 14][i];
    const d = r + nudge;
    return {
      x: parseFloat((cx + d * Math.cos(a)).toFixed(2)),
      y: parseFloat((cy + d * Math.sin(a)).toFixed(2)),
    };
  };

  const gradId = "radarGrad";

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className="w-full h-full"
      style={{ display: "block", overflow: "visible" }}
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(59,81,156,0.7)" />
          <stop offset="100%" stopColor="rgba(123,157,237,0.6)" />
        </linearGradient>
      </defs>

      {Array.from({ length: gridRings }).map((_, lvl) => {
        const pct = ((lvl + 1) / gridRings) * 100;
        return (
          <path
            key={lvl}
            d={ringPath(pct)}
            fill="none"
            stroke="rgba(0,0,0,0.2)"
            strokeWidth="2"
          />
        );
      })}

      <path
        d={dataPath}
        fill={`url(#${gradId})`}
        stroke="#3B519C"
        strokeWidth="2"
        strokeLinejoin="round"
      />

      {labels.map((label, i) => {
        const lp = labelPos(i);
        return (
          <text
            key={i}
            x={lp.x}
            y={lp.y}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="9"
            fontWeight="600"
            fill="#26295E"
            fontFamily="Work Sans, sans-serif"
          >
            {label}
          </text>
        );
      })}
    </svg>
  );
};

export {
  LockIcon,
  BellIcon,
  MessageIcon,
  RadialProgress,
  RadarChart,
  CirclesDeco,
};
